import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getEmployeeForAuth = createAsyncThunk(
  '/getEmployeeForAuth',
  async () => {
    const response = await axios.get('/GetEmployeeForAuth');
    return response.data;
  }
);

export const getTenantsForEmployee = createAsyncThunk(
  '/getTenantsForEmployee',
  async (id) => {
    const response = await axios.get(`/GetTenantsForEmployee/${id}`);
    return response.data;
  }
);

export const getMenuForEmployee = createAsyncThunk(
  '/getMenuForEmployee',
  async (id) => {
    const response = await axios.get(`/GetMenuForEmployee/${id}`);
    return response.data;
  }
);

export const getCommentUser = createAsyncThunk(
  '/getCommentUser',
  async (id) => {
    const response = await axios.get(`/GetCommentUser`);
    return response.data;
  }
);

export const setEmployeeTenants = createAsyncThunk(
  '/SetEmployeeTenants',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetEmployeeTenants',
      data
    );
    return response.data;
  }
);

export const setMenuTenants = createAsyncThunk(
  '/SetMenuTenants',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetMenuTenants',
      data
    );
    return response.data;
  }
);

export const setUserCommentTenants = createAsyncThunk(
  '/SetUserCommentTenants',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetUserCommentTenants',
      data,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    return response.data;
  }
);

export const getApplicationTypes = createAsyncThunk(
  'SetApplications',
  async () => {
    const response = await axiosHeadOffice.get(
      '/HeadOffice/GetApplications'
    );
    return response.data;
  }
)


export const getServiceShopTypes = createAsyncThunk(
  'SetServiceShopTypes',
  async () => {
    const response = await axiosHeadOffice.get(
      '/HeadOffice/GetServiceShopTypes'
    );
    return response.data;
  }
)

export const getActiveMenusByApplicationId = createAsyncThunk(
  'SetActiveMenusByApplicationId',
  async (data) => {
    const response = await axiosHeadOffice.get(
      `/HeadOffice/GetActiveMenusByApplicationId/${data.applicationId}/${data.serviceShopTypeId}`
    );
    return response.data;
  }
)


export const setAuthorizedMenu = createAsyncThunk(
  '/SetAuthorizedMenu',
  async (data) => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetAuthorizedMenu',
      data
    );
    return response.data;
  }
);

const userAuthoritySlice = createSlice({
  name: 'userAuthority',
  initialState: {
    loading: false,
    error: '',
    Employee: [],
    EmployeeTenants: [],
    SelectedEmployeeId: 0,
    IsSelected: false,
    response: '',
    applications: [],
    serviceShopTypes: [],
    menuItems: []
  },
  reducers: {
    changeSelectedEmployeeId(state, action) {
      state.SelectedEmployeeId = action.payload;
    },
    changeIsSelected(state, action) {
      state.IsSelected = action.payload;
    },
    resetDescriptions(state) {
      state.EmployeeTenants = [];
      state.MenuTenants = [];
      state.SelectedEmployeeId = 0;
    },
    setApplications(state, action) {
      state.applications = action.payload;
    },
    updateMenuItems(state, action) {
      const savedMenuItems = [...state.menuItems];

      // Menü elemanını recursive olarak bulup güncelleyecek fonksiyon
      const findAndUpdateItem = (items, id) => {
        for (let item of items) {
          // Eğer item bulunduysa, checked durumunu tersine çeviriyoruz
          if (item.id === id) {
            item.checked = !item.checked;
            return true; // Item bulundu ve güncellendi
          }

          // Eğer alt menüler varsa, recursive olarak alt menüleri kontrol ediyoruz
          if (item.SubMenus && item.SubMenus.length > 0) {
            const foundInSubMenu = findAndUpdateItem(item.SubMenus, id);
            if (foundInSubMenu) return true; // Alt menüde bulunduysa, işlem tamam
          }
        }
        return false; // Eğer item bulunamazsa
      };

      // Ana menüdeki ilk items listesini kontrol ediyoruz
      const items = savedMenuItems[0]?.items;

      if (items.length === 0) return;

      // Menü öğesini bulup güncelliyoruz
      const itemFound = findAndUpdateItem(items, action.payload.id);

      // Eğer item bulunamadıysa, yeni bir öğe olarak ekliyoruz
      if (!itemFound) {
        items.push(action.payload);
      }


      console.log(savedMenuItems)

      state.menuItems = savedMenuItems;

    }
  },

  extraReducers: {
    [getEmployeeForAuth.pending]: (state) => {
      state.loading = true;
    },
    [getEmployeeForAuth.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getEmployeeForAuth.fulfilled]: (state, action) => {
      state.Employee = action.payload;
      state.loading = false;
    },
    [getTenantsForEmployee.pending]: (state) => {
      state.loading = true;
    },
    [getMenuForEmployee.pending]: (state) => {
      state.loading = true;
    },
    [getTenantsForEmployee.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getMenuForEmployee.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTenantsForEmployee.fulfilled]: (state, action) => {
      state.EmployeeTenants = action.payload;
      state.loading = false;
    },
    [getMenuForEmployee.fulfilled]: (state, action) => {
      state.EmployeeMenu = action.payload;
      state.loading = false;
    },
    [setEmployeeTenants.pending]: (state) => {
      state.loading = true;
    },
    [setMenuTenants.pending]: (state) => {
      state.loading = true;
    },
    [setEmployeeTenants.rejected]: (state, action) => {
      state.error = action.error;
    },
    [setMenuTenants.rejected]: (state, action) => {
      state.error = action.error;
    },
    [setEmployeeTenants.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [setMenuTenants.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    [getApplicationTypes.pending]: (state) => {
      state.loading = true;
    },
    [getApplicationTypes.rejected]: (state, action) => {
      state.error = action.error;
    },
    [getApplicationTypes.fulfilled]: (state, action) => {
      state.applications = action.payload;
      state.loading = false;
    },
    [getServiceShopTypes.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopTypes.rejected]: (state, action) => {
      state.error = action.error;
    },
    [getServiceShopTypes.fulfilled]: (state, action) => {
      state.serviceShopTypes = action.payload;
      state.loading = false;
    },
    [getActiveMenusByApplicationId.pending]: (state) => {
      state.loading = true;
    },
    [getActiveMenusByApplicationId.rejected]: (state, action) => {
      state.error = action.error;
    },
    [getActiveMenusByApplicationId.fulfilled]: (state, action) => {
      const mapMenuItems = (items) => {
        return items.map(item => ({
          id: item.Id,
          title: item.TranslationKey,
          checked: item.Checked,
          SubMenus: item.SubMenus ? mapMenuItems(item.SubMenus) : []  // Alt menüler varsa recursive olarak işliyoruz
        }));
      };

      state.menuItems = [
        {
          title: 'Menu Items',
          href: '',
          icon: '',
          items: mapMenuItems(action?.payload)  // Tüm menü yapısını recursive olarak işliyoruz
        }
      ];
      state.loading = false;
    },
    [setAuthorizedMenu.pending]: (state) => {
      state.loading = true;
    },
    [setAuthorizedMenu.rejected]: (state, action) => {
      state.error = action.error;
    },
    [setAuthorizedMenu.fulfilled]: (state, action) => {
      state.loading = false;
    },
  }
});

export const userAuthorityActions = userAuthoritySlice.actions;

export default userAuthoritySlice;
